
export function getCommentsWrapper(postId, callback) {
    $.ajax({
        type: "GET",
        url: '/Blog/GetCommentsWrapper',
        dataType: "html",
        data: {
            PostId: postId
        },
        success: successFunc,
        error: errorFunc
    });

    function successFunc(data, status) {
        $("#comment-wrapper").html(data);
        
        if(typeof callback !== "undefined"){
            callback();            
        }
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
    }
}


export function getPostComments(page = 1) {
    $(".page-item.active").removeClass("active");
    $(".page-item .page-link:contains(" + page + "):first").parent().addClass("active");
    $('.not-found').hide();
    $('.paginatorWraper').show();
    $('.paginatorWraper').find('.pagination:first').addClass('disabled');
    $('.pagination').addClass('disabled');
    $.ajax({
        type: "GET",
        url: '/Blog/GetPostComments',
        dataType: "html",
        data: {
            PostId: document.getElementById('postId').value,
            Page: page, 
            commentsCookie: getCookie("techBlogComments")
        },
        success: successFunc,
        error: errorFunc
    });

    function successFunc(data, status) {
        let elemento = document.getElementById("commentsList");
        $("#commentsList").html(data);
        $('.paginatorWraper').find('.pagination:first').removeClass('disabled');
        $('.pagination').removeClass('disabled');
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
    }
}

export function sendComment(){
    if ($("#commentForm").valid()){
        let sendBtn = document.getElementById("sendCommentBtn");
        sendBtn.disabled = true;
        sendBtn.classList.add("btn-disabled");
        let userCookie = getCookie('techBlogUserId');
        let data = "userId=" + userCookie + "&" + $("#commentForm").serialize();
        
        $.ajax({
            type: 'POST',
            url: '/Blog/CreateComment',
            data: data,
            success: function(response) {
                clearForm();
                sendBtn.disabled = false;
                sendBtn.classList.remove("btn-disabled");
                if(response.success == true){
                    showAlert('success', "¡Gracias por comentar! Su comentario será visible en cuanto sea validado");
                    setCookie("techBlogUserId", response.userId, 365);
                    if(response.commentsCookie !== "" && response.commentsCookie !== "null"){
                        setCommentCookie(response.commentCookie);
                    }
                }else{
                    showAlert('warnning', "No has podido comentar, cumprueba que todos los campos sean correctos");
                }
                
            },
            error: function(response) {
                showAlert("danger", "Algo ha ido mal con su comentario, inténtelo luego");
                sendBtn.disabled = false;
                sendBtn.classList.remove("btn-disabled");
            }
        })
    }
    
}

function clearForm(){
    document.getElementById("commentForm").reset();
}



export function sendDelete(commentId, elementId){
    let commentsCookie = getCookie("techBlogComments");
    let userCookie = getCookie("techBlogUserId");
    $("#"+elementId).html("<spam style='color: red'>¡Comentario eliminado!</spam>");
    $.ajax({
        type: 'POST',
        url: '/Blog/DeleteComment',
        dataType: 'JSON',
        data: {
            commentId: commentId,
            commentCookie: commentsCookie,
            userCookie: userCookie
        },
        success: function(response) {
            getPostComments(1);
            if(response.success == true){
                setCookie("techBlogComments", response.commentCookie, 365);
            }
        },
        error: function(response) {
        }
    })
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return null;
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function setCommentCookie(newCommentCookie){
    let commentsCookie = getCookie("techBlogComments");
    let cvalue = commentsCookie == null ? newCommentCookie : commentsCookie + "|" + newCommentCookie;
    setCookie("techBlogComments", cvalue, 365);
}

function showAlert(type, message){
    let elemAlert = $('#alertComments');
    hiddenAlert();
    switch (type) {
        case "warnning":
            elemAlert.addClass("alert-warning");
            break;
        case "danger":
            elemAlert.addClass("alert-danger");
            break;
        default:
            elemAlert.addClass("alert-success")
            break;
    }
    $("#alertMessage").text(message);
    elemAlert.removeClass("alert-hidden");
}

export function hiddenAlert(){
    let elemAlert = $('#alertComments');
    elemAlert.addClass("alert-hidden");
    elemAlert.removeClass("alert-warning");
    elemAlert.removeClass("alert-success");
    elemAlert.removeClass("alert-danger");
}
